import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap";
import axios from 'axios';
import { BASE_URL } from "../../../constants";

function Packages() {
    const [packages, setPackages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [perPageDropdownOpen, setPerPageDropdownOpen] = useState(false);
    const [errMsg, setErrMsg] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    console.log(packages, 'packages')
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [currentPage, perPage, searchQuery]);

    const togglePerPageDropdown = () => {
        setPerPageDropdownOpen(prevState => !prevState);
    };

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const fetchData = () => {
        const token = localStorage.getItem('token');
        if (token) {
            fetch(`${BASE_URL}/package/list/?page_no=${currentPage}&per_page=${perPage}&q=${searchQuery}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        const formattedPackages = data.result.data.map(pckg => {
                            const formattedPackage = { ...pckg };
                            formattedPackage.created_at = new Date(pckg.created_at).toLocaleDateString('en-US');
                            formattedPackage.updated_at = new Date(pckg.created_at).toLocaleDateString('en-US');
                            return formattedPackage;
                        });
                        setPackages(formattedPackages);
                        setTotalPages(data.result.meta_info.total_pages);
                    } else {
                        console.error("Error: Unable to fetch packages data.");
                    }
                })
                .catch(error => console.error("Error fetching data:", error));
        } else {
            console.error("Error: Authorization token is missing.");
        }
    };

    const handleAddPackage = () => {
        navigate('/package/add');
    };

    const handleEditPackage = (id) => {
        navigate(`/package/edit/${id}`, {
            state: {
                packages: packages
            }
        });
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePerPageChange = (value) => {
        setPerPage(value);
        setCurrentPage(1);
    };


    const handleDeletePackage = async (id) => {
        console.log(`Delete package with ID: ${id}`);

        // Ask for confirmation
        const confirmed = window.confirm("Are you sure you want to delete this package?");

        // If user confirms deletion
        if (confirmed) {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.delete(`${BASE_URL}/package/delete/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setErrMsg(response.data.message);
                fetchData();

            } catch (error) {
                setErrMsg(error);
            }
        }
    };


    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

            <Row>
                <Col xs="6">
                    <h4 className="mt-0">Packages</h4>
                </Col>

                <Col xs="6" className="text-end">
                    <Button color="primary" onClick={handleAddPackage}>Add Package</Button>
                </Col>
            </Row>


            <Card>
                <CardBody>
                    <Row className="my-3">

                        <Col xs="12" className="text-end">
                            <Input
                                type="text"
                                placeholder="Search by title"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
                            />
                        </Col>
                    </Row>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Amount</th>
                                <th>Allowed Properties</th>
                                <th>Allowed Users</th>
                                <th>Trial Days</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                packages.length === 0 ? (
                                    <tr>
                                        <td colSpan="12" className="text-center">
                                            No packages available.
                                        </td>
                                    </tr>
                                )
                                    :
                                    (
                                        packages.map((pckg, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{pckg.title}</td>
                                                <td>{`${pckg.amount} USD`}</td>
                                                <td>{pckg.allowed_properties}</td>
                                                <td>{pckg.allowed_users}</td>
                                                <td>{pckg.trial_days}</td>
                                                <td>
                                                    <Button color="danger" onClick={() => handleDeletePackage(pckg.id)} disabled={pckg.is_trial_package == 1}>Delete</Button>
                                                    <span style={{ marginRight: "5px" }}></span>
                                                    <Button color="warning" onClick={() => handleEditPackage(pckg.id)}>Edit</Button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                        </tbody>

                    </Table>
                </CardBody>

                <Row>
                    <Col xs="4">
                        <div style={{ marginLeft: '25px' }}>
                            <Dropdown isOpen={perPageDropdownOpen} toggle={togglePerPageDropdown}>
                                <DropdownToggle caret color="primary">
                                    Per Page: {perPage}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
                                    <DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
                                    <DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
                                    <DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </Col>

                    <Col xs="8" className="text-right">
                        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>
                            <Pagination aria-label="Page navigation example">
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                       
                                        previous
                                        onClick={() => handlePageClick(currentPage - 1)}
                                    />
                                </PaginationItem>

                                {currentPage > 3 && (
                                    <>
                                        <PaginationItem>
                                            <PaginationLink onClick={() => handlePageClick(1)}>
                                                1
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem disabled>
                                            <PaginationLink>...</PaginationLink>
                                        </PaginationItem>
                                    </>
                                )}

                                {Array.from({ length: 5 }, (_, i) => {
                                    const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
                                    return (
                                        page <= totalPages && (
                                            <PaginationItem key={page} active={currentPage === page}>
                                                <PaginationLink
                                                   
                                                    onClick={() => handlePageClick(page)}
                                                >
                                                    {page}
                                                </PaginationLink>
                                            </PaginationItem>
                                        )
                                    );
                                })}

                                {currentPage < totalPages - 2 && (
                                    <>
                                        <PaginationItem disabled>
                                            <PaginationLink>...</PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem>
                                            <PaginationLink onClick={() => handlePageClick(totalPages)}>
                                                {totalPages}
                                            </PaginationLink>
                                        </PaginationItem>
                                    </>
                                )}

                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                        
                                        next
                                        onClick={() => handlePageClick(currentPage + 1)}
                                    />
                                </PaginationItem>
                            </Pagination>

                        </div>
                    </Col>
                </Row>
            </Card>
        </div>
    );
}

export default Packages;
